module.exports = __webpack_public_path__ + "img/sub19.4049bf9e.jpg";